import React from 'react'

import StarRating from '@f/components/StarRating'

const QuizBottomCheckoutDesktop = ({ text }) => {
  const copy =
    text ||
    (window.__DOMAIN__ === 'fertighaus' ? (
      <span>
        Wir haben <strong>3 Anbieter</strong> und <strong>54 Häuser</strong> für
        Sie gefunden!
      </span>
    ) : (
      <span>
        Wir haben <strong>54 Häuser</strong> von passenden Baupartnern gefunden!
      </span>
    ))

  if (text === '{none}') {
    return null
  }

  return (
    <div className='QuizApp-checkout-image'>
      <p className='f-t-body f-c-fo-whi f-t-centre'>{copy}</p>
      <p className='QuizApp-checkout-image--text'>
        <StarRating />
        <strong>4,4 / 5</strong> von über <strong>53713</strong> Kunden
      </p>
    </div>
  )
}

export default QuizBottomCheckoutDesktop
